import { IMerchantCartProductsDictionary } from "interfaces/Carts/carts.interface";
import { getStoreUsernameInAuth } from "./auth";

let timeoutId: NodeJS.Timeout | null = null;
let timeoutRecieveMessageFlagger: NodeJS.Timeout | null = null;

const NAMESPACES = {
  cart_data: "cart_data",
  send_react_native_initial_data: "send_react_native_initial_data",
};

const sendMessageToRNWebView = (message: string) => {
  if (window?.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(message);
  }
};

const sendCartObjectToRNWebView = (cartObject: IMerchantCartProductsDictionary) => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  timeoutId = setTimeout(() => {
    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          data: cartObject,
          storeUsername: getStoreUsernameInAuth(),
          namespace: "cart_data",
        }),
      );
    }
  }, 1000);
};

const sendReadyToReceiveMessageToRNWebView = () => {
  if (timeoutRecieveMessageFlagger) {
    clearTimeout(timeoutRecieveMessageFlagger);
  }

  timeoutRecieveMessageFlagger = setTimeout(() => {
    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          namespace: NAMESPACES.send_react_native_initial_data,
        }),
      );
    }
  }, 500);
};

export { sendMessageToRNWebView, sendCartObjectToRNWebView, sendReadyToReceiveMessageToRNWebView };
